import React, { useState, useEffect, useContext } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import { UserContext } from "context/auth";

import useFetchStatus from 'customHooks/useFetchStatus'
import ReactTable from 'main_views/components/ReactTable'
import Alert from "main_views/components/alert"
import { successToast, errorToast } from 'main_views/components/toast'
import StaffModal from './staffModal'
import TitleWithBtn from 'main_views/components/Titles/TitleWithBtn'

function Staff(props) {

    let { t } = useTranslation()

    let { user: currentUser } = useContext(UserContext)

    let [updateList, setUpdateList] = useState(0)
    let [staff, staffError, staffIsLoading] = useFetchStatus(`staff`, {}, [updateList])
    let [staffData, setStaffData] = useState([])
    let [filteredData, setFilteredData] = useState()
    let [selectedStaff, setSelectedStaff] = useState()
    
    // modals
    let [showNewStaffModal, setNewStaffModal] = useState(false)
    let [showEditModal, setEditModal] = useState(false)
    
    // alert
    let [alert, setAlert] = useState(null)

    // loading
    let [isDeleting, setIsDeleting] = useState(false)

    useEffect(() => {
        
        // hide the current logged user from the list
        delete staff[currentUser.id]

        let staffList = _.values(staff)
        setStaffData(staffList)

    }, [staff])

    let header = [
        {
            Header: t('id'),
            accessor: 'staff_number',
            sortable: true,
            type: 'string'
        },
        {
            Header: t('name'),
            accessor: 'name_en',
            sortable: true,
            type: 'string'
        },
        {
            Header: t('department'),
            accessor: 'department',
            sortable: true,
            type: 'string'
        },
        {
            Header: t('role'),
            accessor: 'role',
            sortable: true,
            type: 'string'
        },
        {
            Header: t('email'),
            accessor: 'email',
            sortable: true,
            type: 'string'
        },
        {
            Header: t('can_take_action'),
            accessor: 'permissons.CanTakeAction',
            sortable: true,
            type: 'checkbox'
        },
        {
            Header: t('can_generate_form'),
            accessor: 'permissons.CanGenerateForm',
            sortable: true,
            type: 'checkbox'
        },
        {
            Header: t('can_add_staff'),
            accessor: 'permissons.CanAddStaff',
            sortable: true,
            type: 'checkbox'
        },
        {
            Header: t('can_set_priority'),
            accessor: 'permissons.CanSetPriority',
            sortable: true,
            type: 'checkbox'
        },
        {
            Header: t('can_redirect_request'),
            accessor: 'permissons.CanRedirectRequest',
            sortable: true,
            type: 'checkbox'
        },
        {
            Header: t('can_see_all_tickets'),
            accessor: 'permissons.CanSeeAllTickets',
            sortable: true,
            type: 'checkbox'
        },
        {
            Header: t('can_complete_request'),
            accessor: 'permissons.CanCompleteRequest',
            sortable: true,
            type: 'checkbox'
        },
        {
            Header: '',
            sortable: false,
            type: 'editAndDeleteButtons',
            onEdit: (idx) => {
                setSelectedStaff(filteredData ? filteredData[idx] : staffData[idx])
                setEditModal(true)
            },
            onDelete: (idx) => deleteConfirmAlert(idx),
        },
    ]

    let deleteConfirmAlert = (index) => {

        let data = filteredData ? filteredData[index] : staffData[index]

        setAlert({
            show: true,
            isError: true,
            title: `${t('delete')} \n${data.name_en}`,
            msg: t('are_you_sure_you_want_to_do_this_action'),
            confirmBtnText: t('yes_delete_it'),
            cancelBtnText: t('cancel'),
            showCancelBtn: true,
            handelCancel: () => setAlert(null),
            handelConfirm: () => {
                setAlert(null)
                deleteStaff(data)
            },
        })
    }
        

    let deleteStaff = async (data) => {

        let { id, uid } = data

        try {

            setIsDeleting(true)

            let url = `https://us-central1-tickting-system.cloudfunctions.net/deleteStaff?uid=${uid}&staffDocId=${id}`

            let response = await fetch(url)

            if (!response.ok)
                throw new Error('')

            updateFormList()
            successToast(t('form_was_deleted'))


        } catch (error) {
            console.log("delete staff: ", error)

            errorToast(t('something_wrong'))

        } finally {

            setIsDeleting(false)

        }

    }

    let updateFormList = () => setUpdateList(++updateList)

    return (
        <div className='content'>

            <TitleWithBtn
                title={t('staff_list')}
                button={{
                    title: t('add_new_staff'),
                    onClick: () => {
                        setSelectedStaff()
                        setNewStaffModal(true)
                    }
                }}
            />

            {/* Staff list */}
            <ReactTable
                title={t('staff_list')}
                header={header}
                body={staffData}
                hasSearchBar={true}
                setFilterResult={setFilteredData}
                loading={staffIsLoading || isDeleting}
                pageRows={50}
            />


            {/* add new staff modal */}
            <StaffModal
                isOpen={showNewStaffModal}
                isEdit={false}
                staffList={staff}
                staffIsLoading={staffIsLoading}
                toggle={() => setNewStaffModal(false)}
                updateFormList={updateFormList}
            />


            {/* Edit staff info modal */}
            <StaffModal
                isEdit={true}
                selectedStaff={selectedStaff}
                isOpen={showEditModal}
                staffList={staff}
                staffIsLoading={staffIsLoading}
                toggle={() => setEditModal(false)}
                updateFormList={updateFormList}
            />

            <Alert {...alert} />

        </div>

    )
}

export default Staff
